const initialState = {
  auth_email_id: "",
  auth_name: "",
  auth_id: "",
  role: [],
  token: "XEb2orlCYjDYQaTCzFiOP6CwK-oYzsnJK3b7Vy5f6LA",
};

const auth = (state = initialState, action) => {
  switch (action.type) {
    // case "CONTACT_DATA_GET":
    //   return { ...state, auth_email_id: action.payload };

    // case "AUTH_DATA":
    //   return {
    //     ...state,
    //     auth_name: action.auth_name,
    //     auth_email_id: action.auth_email_id,
    //     auth_id: action.auth_id,
    //     user_token: action.user_token,
    //     role: action.role,
    //   };
    default:
      return state;
  }
};
export default auth;
